export default {
    defaultColor:['warn' ,'primary','accent']
}